import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { ConfirmPasswordValidator } from 'src/app/modules/auth';
import { PassChange, AuthModel } from 'src/app/modules/auth/_models/auth.model';
import { NewUserModel, UserModel } from 'src/app/modules/auth/_models/user.model';
import { AuthService } from 'src/app/modules/auth/_services/auth.service';
import { LayoutService } from '../../../../_metronic/core';

enum ErrorStates {
    NotSubmitted,
    HasError,
    NoError,
    CodeError,
    HasSuccess,
    UserCreated
  }
  
@Component({
  selector: 'app-header-mobile',
  templateUrl: './header-mobile.component.html',
  styleUrls: ['./header-mobile.component.scss'],
})
export class HeaderMobileComponent implements OnInit, AfterViewInit {
  headerLogo = '';
  asideSelfDisplay = true;
  headerMenuSelfDisplay = true;
  headerMobileClasses = '';
  headerMobileAttributes = {};
  
  user$: Observable<UserModel>;
  _user: UserModel;
  newUser: NewUserModel;
  forgotPasswordForm: FormGroup;
  changePasswordForm: FormGroup;
  createUserForm: FormGroup;
  errorState: ErrorStates = ErrorStates.NotSubmitted;
  errorStates = ErrorStates;
  isLoading$: Observable<boolean>;
  secureCode: string = "";
  closeResult: string;
  modalTemplate: number = 1;

   // private fields
   private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

  
  constructor(
      private layout: LayoutService, 
      private modalService: NgbModal,
    private authService: AuthService,
    private fb: FormBuilder) {}

  ngOnInit(): void {
    // build view by layout config settings
    this.headerMobileClasses = this.layout.getStringCSSClasses('header_mobile');
    this.headerMobileAttributes = this.layout.getHTMLAttributes(
      'header_mobile'
    );

    this.headerLogo = this.getLogoUrl();
    this.asideSelfDisplay = this.layout.getProp('aside.self.display');
    this.headerMenuSelfDisplay = this.layout.getProp(
      'header.menu.self.display'
    );

    this.user$ = this.authService.currentUserSubject.asObservable();
    this.user$.subscribe(u=> {
    	this._user = u;
    });

    this.initForm();
  }

  ngAfterViewInit() {
    // Init Header Topbar For Mobile Mode
    //this.KTLayoutHeaderTopbar.init('kt_header_mobile_topbar_toggle');
  }

  private getLogoUrl() {
    const headerSelfTheme = this.layout.getProp('header.self.theme') || '';
    const brandSelfTheme = this.layout.getProp('brand.self.theme') || '';
    let result = 'logo-dark.png';
    if (!this.asideSelfDisplay) {
      if (headerSelfTheme === 'light') {
        result = 'logo-dark.png';
      }
    } else {
      if (brandSelfTheme === 'light') {
        result = 'logo-dark.png';
      }
    }
    return `./assets/media/logos/${result}`;
  }

// convenience getter for easy access to form fields
get f() {
    return this.forgotPasswordForm.controls;
  }

  get g() {
    return this.changePasswordForm.controls;
  }

  get c() {
    return this.createUserForm.controls;
  }

  initForm() {
    this.forgotPasswordForm = this.fb.group({
      email: [
        '',
        Validators.compose([
          Validators.required,
          Validators.email,
          Validators.minLength(3),
          Validators.maxLength(320), // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
        ]),
      ],
    });

    this.changePasswordForm = this.fb.group({
      code: [
        '',
        Validators.compose([
          Validators.required,
        ]),
      ],
      password: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
        ]),
      ],
      repeatPassword: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
        ]),
      ]
    },
    {
      validator: ConfirmPasswordValidator.MatchPassword,
    });

    this.createUserForm = this.fb.group({
      email: [
        '',
        Validators.compose([
          Validators.email,
          Validators.required,
        ]),
      ],
      password: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
        ]),
      ],
      repeatPassword: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
        ]),
      ]
    },
    {
      validator: ConfirmPasswordValidator.MatchPassword,
    });
  }

  onCreateUser(modal) {
    if(this._user.isAdmin != 1) {
      return false;
    }

	  this.errorState = ErrorStates.NoError;
	  this.modalTemplate = 1;

    this.modalService.open(modal).result.then((result) => {
      console.log(result)
    }, (reason) => { // this.getDismissReason(reason)
        
    });

  }

  submitCreateUser() {
	const createUserSubscr = this.authService
	.createUserMode2({
		Email : this.c.email.value,
		Clave : this.c.password.value 
	})
	.pipe(first())
	.subscribe((result: PassChange) => {
		console.log(result);
		if(result == undefined) {
			this.errorState = ErrorStates.HasError;
			return false;
		}
		this.errorState = result[0].Success ? ErrorStates.UserCreated : ErrorStates.HasError;

		if(this.errorState == 5) {
			this.modalTemplate = 2;
		}
	});

	this.unsubscribe.push(createUserSubscr);
  }

  submitRequestCode(step) {
    this.errorState = ErrorStates.NotSubmitted;

    if(step == 1) {
      const forgotPasswordSubscr = this.authService
      .forgotPasswordMode2()
      .pipe(first())
      .subscribe((result: PassChange) => {
        this.errorState = result[0].Success ? ErrorStates.NoError : ErrorStates.HasError;
        this.secureCode = result[0].Codigo;

        if(this.errorState == 2) {
          this.modalTemplate = 2;
        }
      });

      this.unsubscribe.push(forgotPasswordSubscr);
    }
  }

  submitChangePassword(step) {
    this.errorState = ErrorStates.NotSubmitted;

    if(step == 2 && this.secureCode == this.g.code.value) {
      const changePasswordSubscr = this.authService
      .changePasswordMode2(this.g.code.value, this.f.email.value, this.g.password.value)
      .pipe(first())
      .subscribe((result: PassChange) => {
        this.errorState = result[0].Success ? ErrorStates.HasSuccess : ErrorStates.CodeError;
        if(this.errorState) {
          this.modalTemplate = 3;

          return true;
        }
      });

    }
    else {
      this.errorState = ErrorStates.CodeError;
    }

    return false;
  }

  onChangePassword(modal) {
    this.modalService.open(modal).result.then((result) => {
      console.log(result)
    }, (reason) => { // this.getDismissReason(reason)
        
    });
  }

  logout() {
    this.authService.logout();
    document.location.reload();
  }


  openDropdowm(selector = "kt_header_menu_wrapper") {
    var li = (document.getElementById(selector) as HTMLButtonElement)

    if(li.classList.contains("header-menu-wrapper-on")) {
      li.classList.remove("header-menu-wrapper-on");
    }
    else {
        li.classList.add("header-menu-wrapper-on");
    }

    console.log(li.classList.value);
  }
}
